import * as constants from './copy-paste-constants';

export function genericCopyItem(payload) {
  return { type: constants.COPY_ITEM, payload };
}



// WEBPACK FOOTER //
// ./src/app/stores/copy-paste/copy-paste-actions.js